import { Button, Table, Tag } from "antd";
import React, { useContext, useState } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import moment from "moment";

export const CountWantedInfo = ({ data, handleViewForm, condition }) => {
  console.log("data", data);
  const handleViewForm1 = (id) => {
    console.log("id", id);
    handleViewForm(id);
  };
  const { t } = useContext(LanguageContext);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination, filters, sorter) => {
    setPagination({
      ...pagination,
      pageSize: pagination.pageSize,
    });
  };
  const dataList =
    condition!="तडीपार"
      ? {
          columns: [
            {
              title: t("sr.no"),
              dataIndex: "srNo",
              key: "srNo",
            },
            {
              title: t("police_station_required"),
              dataIndex: "policeSideNeed",
              key: "policeSideNeed",
              render: (text, record) => <div>{record?.policeSideNeed}</div>,
            },
            {
              title: t("name"),
              dataIndex: "name",
              key: "name",

              render: (text) => <div>{text}</div>,
            },
            {
              title: t("accused_police_station"),
              dataIndex: "crime_districtName",
              key: "crime_districtName",
              render: (text, record) => <div>{record?.crime_districtName}</div>,
            },
            {
              title: t("total_crimes"),
              key: "totalCrimeCount",
              dataIndex: "totalCrimeCount",
              render: (text, record) => <div>{record.totalCrimeCount}</div>,
            },
            {
              title: t("action"),
              key: "action",
              render: (text, record) => (
                <div className="action-links-responsive">
                  <Button
                    type="text"
                    size="small"
                    className="action-link update-link"
                    onClick={() => {
                      handleViewForm1(record.masterId);
                    }}
                  >
                    {t("view1")}
                  </Button>
                </div>
              ),
            },
          ],

          rows: (data || []).map((item, index) => ({
            key: index,
            srNo: index + 1,
            policeSideNeed: item?.policeSideNeed,
            crime_districtName: item.districtName,
            name: item?.name,
            totalCrimeCount: item?.gunhaCount,
            masterId: item.id || "-",
          })),
        }
      : {
          columns: [
            {
              title: t("sr.no"),
              dataIndex: "srNo",
              key: "srNo",
            },
            {
              title: t("police_station_action_by"),
              dataIndex: "action_taken_police_station",
              key: "action_taken_police_station",
              render: (text, record) => (
                <div>{record?.action_taken_police_station || "-"}</div>
              ),
            },
            {
              title: t("name"),
              dataIndex: "name",
              key: "name",
              render: (text) => <div>{text || "-"}</div>,
            },
            {
              title: t("accused_police_station"),
              dataIndex: "districtName",
              key: "districtName",
              render: (text, record) => <div>{record?.districtName || "-"}</div>,
            },
            {
              title: t("total_crimes"),
              key: "totalCrimeCount",
              dataIndex: "totalCrimeCount",
              render: (text, record) => (
                <Button
                  type="primary"
                  shape="circle"
                  size="small"
                  style={{
                    width: 36,
                    height: 36,
                    fontWeight: 600,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  }}
                  disabled={!record.totalCrimeCount}
                >
                  {record.totalCrimeCount || 0}
                </Button>
              ),
            },
            {
              title: t("period_from"),
              key: "date_from",
              dataIndex: "date_from",
              render: (text, record) => (
                <div>
                  {record.date_from
                    ? moment(record.date_from).format("DD/MM/YYYY")
                    : "-"}
                </div>
              ),
            },
            {
              title: t("period_to"),
              key: "date_to",
              dataIndex: "date_to",
              render: (text, record) => (
                <div>
                  {record.date_to
                    ? moment(record.date_to).format("DD/MM/YYYY")
                    : "-"}
                </div>
              ),
            },
            {
              title: t("preventive_action_status"),
              key: "preventiveActionStatus",
              render: (text, record) => {
                const today = moment().startOf("day");
                const dateFrom = record.date_from
                  ? moment(record.date_from)
                  : null;
                const dateTo = record.date_to ? moment(record.date_to) : null;

                if (dateFrom && dateTo) {
                  if (today.isBetween(dateFrom, dateTo, "day", "[]")) {
                    return <Tag color="blue">{t("ongoing")}</Tag>;
                  }
                  if (dateTo.isBefore(today, "day")) {
                    return <Tag color="green">{t("completed")}</Tag>;
                  }
                }
                return "-";
              },
            },
            {
              title: t("preventive_action_name"),
              dataIndex: "preventiveActionName",
              key: "preventiveActionName",
              render: (text) => <div>{text || "-"}</div>,
            },
            {
              title: t("action"),
              key: "action",
              render: (text, record) => (
                <div className="action-links-responsive">
                  <Button
                    type="text"
                    size="small"
                    className="action-link update-link"
                    onClick={() => {
                      handleViewForm1(record.masterId);
                    }}
                  >
                    {t("view1")}
                  </Button>
                </div>
              ),
            },
          ],

          rows: (data || []).map((item, index) => ({
            key: item?.id || item?.masterId || index,
            srNo: index + 1,
            action_taken_police_station: item?.action_taken_police_station,
            districtName: item?.districtName,
            name: item?.name,
            totalCrimeCount: item?.totalCrimeCount || item?.gunhaCount || 0,
            date_from: item?.date_from,
            date_to: item?.date_to,
            preventiveActionName: item?.preventiveActionName,
            masterId: item?.masterId || item?.id,
          })),
        };
  return (
    <>
      <Table
        scroll={{ x: "max-content" }}
        columns={dataList.columns}
        dataSource={dataList.rows}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          showSizeChanger: true,
        }}
        onChange={handleTableChange}
      />
    </>
  );
};
